import React from "react";
import "./DegreeCard.css";

const strip = (s) => s.replace(/^[^\w]+/, "").trim();

export default function DegreeCard({ degree }) {
  return (
    <div className="tl-card-wrap">
      <article className="deg-card">
        <header className="deg-head">
          {degree.logo_path && (
            <div className="deg-logo">
              <img
                src={require(`../../assests/images/${degree.logo_path}`)}
                alt={degree.alt_name}
              />
            </div>
          )}
          <div className="deg-titles">
            <h3>{degree.title.trim()}</h3>
            <p>{degree.subtitle}</p>
          </div>
          <span className="chip chip-mono">{degree.duration}</span>
        </header>
        <ul className="deg-points">
          {degree.descriptions.map((d) => (
            <li key={d}>{strip(d)}</li>
          ))}
        </ul>
        {degree.website_link && (
          <a
            className="btn btn-ghost btn-sm"
            href={degree.website_link}
            target="_blank"
            rel="noopener noreferrer"
          >
            Visit website ↗
          </a>
        )}
      </article>
    </div>
  );
}
